import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { ActivityParentEntityId, toPhoneNumberE164 } from "@sp-crm/core";
import { useDefaultActivityTypeId } from "components/tasks/activity-type-options";
import { defaultLinkColour } from "components/ui/link";
import React from "react";
import { usePhoneLines } from "store/selectors/telecom";
import { telecomAvailable } from "./phone-action";
import { SendSmsPanel } from "./send-sms-panel";

interface PhoneSmsButtonProps {
    value: string;
    entityId: ActivityParentEntityId | null;
}

export const PhoneSmsButton: React.FC<PhoneSmsButtonProps> = props => {
    const { value, entityId } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const sendingPhoneNumbers = usePhoneLines();
    const activityTypeId = useDefaultActivityTypeId("sms", null);

    const handleSms = React.useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(true);
    }, []);

    const handleDismiss = React.useCallback(() => {
        setIsOpen(false);
    }, []);

    if (!telecomAvailable(value, sendingPhoneNumbers.length)) {
        return null;
    }

    return (
        <>
            <div>
                <a href="#" className={defaultLinkColour} onClick={handleSms}>
                    <ChatBubbleLeftIcon className="w-5 h-5" />
                </a>
            </div>
            <SendSmsPanel
                activityTypeId={activityTypeId}
                isOpen={isOpen}
                onDismiss={handleDismiss}
                recipient={toPhoneNumberE164(value)}
                entityId={entityId}
            />
        </>
    );
};
